<main class="container">
    <section id="column2">
        <div class="user-guide-layout">

    <!-- Sidebar -->
    <aside class="user-guide-sidebar" aria-label="User Guide Navigation">
        <div class="sidebar-header">
            <mat-icon class="sidebar-header-icon">menu_book</mat-icon>
            <span class="sidebar-header-title">User Guide</span>
        </div>

        <nav class="sidebar-nav">
            @for (chapter of chapters; track chapter.folderId) {
            <button class="sidebar-nav-item" [class.active]="activeChapter?.folderId === chapter.folderId"
                (click)="loadChapter(chapter)"
                [attr.aria-current]="activeChapter?.folderId === chapter.folderId ? 'page' : null"
                [title]="chapter.title">
                <span class="sidebar-nav-label">{{ chapter.title }}</span>
            </button>
            }
        </nav>
    </aside>

    <!-- Content area -->
    <div class="user-guide-content" aria-label="User Guide Content">
        @if (isLoading) {
        <div class="content-loading">
            <app-spinner></app-spinner>
        </div>
        } @else {
        <article class="content-body markdown-body" [innerHTML]="renderedContent" (click)="onContentClick($event)">
        </article>
        }
    </div>
        </div>
    </section>
</main>